"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeProvider = ThemeProvider;
exports.default = void 0;
exports.useTheme = useTheme;
exports.withThemeProp = withThemeProp;
exports.withThemes = withThemes;
var _react = require("react");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
const ThemeContext = /*#__PURE__*/(0, _react.createContext)("");
function ThemeProvider(_ref) {
  let {
    children,
    theme
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ThemeContext.Provider, {
    value: theme !== null && theme !== void 0 ? theme : "",
    "data-testid": "ThemeProvider",
    children: children
  });
}
function useTheme() {
  return (0, _react.useContext)(ThemeContext);
}
function withThemeProp(Component) {
  return (0, _styledComponents.default)(Component)`
    ${function (_ref2) {
    let {
      theme
    } = _ref2;
    return theme;
  }}
  `;
}
function withThemes(Component, themes) {
  const ThemedComponent = withThemeProp(Component);
  const _ = function (props) {
    const defaultTheme = (0, _react.useContext)(ThemeContext);
    const {
      theme
    } = props;
    const themeKey = theme || defaultTheme || "";
    let themeValue;
    if (typeof themeKey === "string") {
      themeValue = themes[themeKey];
    } else {
      themeValue = Object.keys(themeKey).map(function (k) {
        var _themes$k;
        return themes === null || themes === void 0 ? void 0 : (_themes$k = themes[k]) === null || _themes$k === void 0 ? void 0 : _themes$k[themeKey === null || themeKey === void 0 ? void 0 : themeKey[k]];
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ThemeProvider, {
      theme: themeKey,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ThemedComponent, {
        ...props,
        theme: themeValue
      })
    });
  };
  _.displayName = Component.displayName || Component.name;
  return _;
}
var _default = exports.default = withThemes;